import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Card from '../components/common/Card';
import Button from '../components/common/Button';
import Input from '../components/common/Input';
import { toast } from 'react-toastify';
import api from '../services/api';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

const AlumniLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: '',  // This should be mobile number
    password: ''
  });

  // Check if already logged in
  useEffect(() => {
    const token = localStorage.getItem('alumni_token');
    if (token) {
      navigate('/alumni/dashboard');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log('Form submission - Username:', formData.username);
    console.log('Form submission - Password length:', formData.password?.length);

    if (!formData.username || !formData.password) {
      toast.error('Please enter both mobile number and password');
      return;
    }

    // Validate mobile number format (Kenyan phone number)
    const mobileRegex = /^07[0-9]{8}$/;
    if (!mobileRegex.test(formData.username)) {
      toast.error('Please enter a valid mobile number (e.g., 0712345678)');
      return;
    }

    setLoading(true);
    try {
      const response = await api.post('/alumni/login', {
        username: formData.username,  // This should be the mobile number
        password: formData.password
      });

      if (response.data.success) {
        localStorage.setItem('alumni_token', response.data.token);
        localStorage.setItem('alumni_user', JSON.stringify(response.data.user));
        
        toast.success('Login successful! Redirecting to dashboard...');

        setTimeout(() => {
          navigate('/alumni/dashboard');
        }, 1500);
      } else {
        toast.error(response.data.message || 'Login failed');
      }
    } catch (error) {
      console.error('Login error:', error);
      if (error.response?.status === 401) {
        toast.error('Invalid credentials. Please check your mobile number and admission number.');
      } else if (error.response?.status === 403) {
        toast.error('Access denied. This portal is for alumni only.');
      } else {
        toast.error(error.response?.data?.message || 'Login failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div style={{ backgroundColor: '#FEFBEC', minHeight: 'calc(100vh - 140px)' }}>
        {/* Hero Section */}
        <div className="bg-white border-b-4 border-[#fbbf24] shadow-sm">
          <div className="container mx-auto px-4 sm:px-6 py-3 sm:py-4">
            <div className="flex items-center gap-3 sm:gap-4">
              <div className="w-8 h-8 sm:w-10 sm:h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-lg sm:text-xl">🎓</span>
              </div>
              <div>
                <h1 className="text-lg sm:text-xl font-bold text-gray-800 mb-0.5">
                  Alumni Portal Login
                </h1>
                <p className="text-xs sm:text-sm text-gray-600">
                  Access your alumni account with your mobile number and admission number
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12">
          <div className="max-w-md mx-auto">
            <Card className="p-6 sm:p-8">
              <form onSubmit={handleSubmit}>
                <div className="space-y-5">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      📱 Mobile Number (Username)
                    </label>
                    <Input
                      type="tel"
                      value={formData.username}
                      onChange={(e) => setFormData({...formData, username: e.target.value})}
                      placeholder="0712345400"
                      required
                    />
                    <p className="text-xs text-gray-500 mt-1">Enter your registered mobile number (e.g., 0712345400)</p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      🔑 Password (Admission Number)
                    </label>
                    <Input
                      type="password"
                      value={formData.password}
                      onChange={(e) => setFormData({...formData, password: e.target.value})}
                      placeholder="CEE/301/S2023"
                      required
                    />
                    <p className="text-xs text-gray-500 mt-1">Enter your admission number as password (e.g., CEE/301/S2023)</p>
                  </div>

                  <Button type="submit" className="w-full py-3" disabled={loading}>
                    {loading ? 'Logging in...' : 'Login to Alumni Portal'}
                  </Button>
                </div>
              </form>

              <div className="mt-6 text-center">
                <p className="text-sm text-gray-600">
                  Not registered yet?{' '}
                  <Link to="/alumni/register" className="text-primary hover:underline">
                    Register as Alumnus
                  </Link>
                </p>
              </div>

              <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                <p className="text-xs text-yellow-800">
                  <strong>📝 Test Credentials:</strong><br />
                  • Mobile Number: <span className="font-mono font-bold">0712345400</span><br />
                  • Password: <span className="font-mono font-bold">CEE/301/S2023</span><br />
                  <span className="text-xs mt-1 block">⚠️ Make sure to enter the mobile number (not the admission number) in the first field</span>
                </p>
              </div>
            </Card>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AlumniLogin;
